import { ApolloClient, ApolloLink, createHttpLink, DefaultOptions, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

import { getLocalStorageItem } from '../utils/utils';

export const httpLink = createHttpLink({ uri: window.runtime_env?.REACT_APP_API_URL || process.env.REACT_APP_API_URL });

//@ts-ignore
export const onErrorLink = onError(({ graphQLErrors, operation, forward, ...rest }) => {
  if (graphQLErrors) {
    for (let err of graphQLErrors) {
      if (err?.extensions?.code === 'UNAUTHENTICATED') {
        window.location.href = `${window.tz_globalConfigs.customUrlPrefix || ''}/mybooking/?bookingCode=${operation.variables.bookingCode}`;
        return forward(operation);
      }
    }
  }
});

export const authLink = new ApolloLink((operation, forward) => {
  const userIdentity = getLocalStorageItem<string>('userIdentity');

  if (userIdentity) {
    operation.setContext({
      headers: {
        'X-User-Identity': `${encodeURIComponent(userIdentity)}`,
      },
    });
  }

  return forward(operation);
});

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
};

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([
    onErrorLink,
    authLink,
    httpLink,
  ]),
  cache: new InMemoryCache(),
  defaultOptions,
});
